/* eslint-disable @typescript-eslint/no-non-null-assertion */
export const SERVER_URL = process.env.REACT_APP_SERVER_URL ?? '/'
